module.exports = __webpack_public_path__ + "img/planIndividualColor.2921201d.png";